/**
 * Frontend mirror of backend/config/crmConfig.js.
 * Every workflow difference between India and France is expressed here.
 */

export const EU_COUNTRIES = [
  'France', 'Germany', 'Italy', 'Spain', 'Portugal', 'Netherlands', 'Belgium',
  'Luxembourg', 'Austria', 'Ireland', 'Greece', 'Poland', 'Czech Republic',
  'Romania', 'Hungary', 'Sweden', 'Denmark', 'Finland', 'Croatia', 'Slovakia',
  'Slovenia', 'Lithuania', 'Latvia', 'Estonia', 'Bulgaria', 'Cyprus', 'Malta',
];

export const CRM_CONFIG = {
  INDIA: {
    label: 'India',
    flag: '🇮🇳',
    flagCode: 'IN',
    defaultPhoneCode: '+91',
    defaultTimezone: 'Asia/Kolkata',
    currency: ['AED', 'EURO', 'GBP', 'USD', 'EUR', 'LKR'],
    features: {
      meetingRequired: true,
      mockInterviewRequired: true,
      interviewRequired: true,
      agreementVerification: true,
      visaModule: true,
      refundModule: true,
      companyModule: false,
      jobMapping: false,
      mailAutoConfig: false,
      interestedCourse: false,
      feeTypes: ['application_fee', 'tuition_fee', 'registration_fee', 'visa_fee', 'other'],
    },
    workflow: {
      interviewOutcomeRequiresReport: false,
      employeeCanPassFail: false,
    },
  },
  FRANCE: {
    label: 'France',
    flag: '🇫🇷',
    flagCode: 'FR',
    defaultPhoneCode: '+33',
    defaultTimezone: 'Europe/Paris',
    currency: ['EUR', 'GBP'],
    features: {
      meetingRequired: false,
      mockInterviewRequired: false,
      interviewRequired: true,
      agreementVerification: false,
      visaModule: 'conditional',
      refundModule: 'conditional',
      companyModule: true,
      jobMapping: true,
      mailAutoConfig: true,
      interestedCourse: true,
      feeTypes: ['application_fee', 'tuition_fee', 'registration_fee', 'visa_fee', 'installment', 'alternance', 'other'],
    },
    workflow: {
      interviewOutcomeRequiresReport: true,
      employeeCanPassFail: true,
    },
  },
};

export const VALID_COUNTRIES = Object.keys(CRM_CONFIG);

export function getCountryConfig(code) {
  return CRM_CONFIG[String(code || '').toUpperCase()] || CRM_CONFIG.INDIA;
}

export function isEUNationality(nationality) {
  if (!nationality) return false;
  const n = String(nationality).trim().toLowerCase();
  return EU_COUNTRIES.some((c) => c.toLowerCase() === n);
}
